import { render } from "./MainLayout.vue?vue&type=template&id=616b01d5&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=616b01d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-616b01d5"

export default script